export default __webpack_public_path__ + "static/media/more-nature.a7989671.svg";